import { Component, OnInit } from '@angular/core';
import { PermissionsService, MenuItem } from '../../core/permissions.service';
import { SessionService } from '../../core/session.service';

export interface SubMenuItem {
  url: string;
  text: string;
}

@Component({
  standalone: false,
  selector: 'app-left-nav',
  templateUrl: './left-nav.component.html',
  styleUrls: ['./left-nav.component.scss']
})
export class LeftNavComponent implements OnInit {
  subMenus: { [url: string]: SubMenuItem[] } = {};

  constructor(
    public perms: PermissionsService,
    private session: SessionService
  ) {}

  ngOnInit(): void {
    this.session.loaded$.subscribe(loaded => {
      if (loaded) this.buildSubMenus();
    });
  }

  private buildSubMenus(): void {
    const user = this.session.userInfo;
    if (!user) return;

    this.subMenus['/quotes'] = this.buildRecentItems(
      user.recent_quotes, 'QT #: ', '/quotes/'
    );
    this.subMenus['/orders'] = this.buildRecentItems(
      user.recent_orders, 'SO #: ', '/orders/'
    );
    // V1 parity: RMAs are scoped under /orders/:id/viewrma (RMAs always belong
    // to a parent SO, so the menu items use the SO # and route into the order
    // detail in viewrma mode). "See All" still points at /rmas.
    this.subMenus['/rmas'] = this.buildRecentItems(
      user.recent_rmas, 'SO #: ', '/orders/', '/viewrma', '/rmas'
    );
    this.subMenus['/products'] = this.buildRecentItems(
      user.recent_products, 'Part: ', '/product/'
    );

    // Favorites sub-menu - mdFavorites may be an object or array depending on response
    const rawFavs = this.session.data['mdFavorites'];
    const favs = (Array.isArray(rawFavs) ? rawFavs : [])
      .filter((f: any) => f.Status === '1')
      .slice(0, 5);
    this.subMenus['/favorites'] = favs.map((f: any) => ({
      url: f.Url || '',
      text: f.FavoriteID
    }));
    if (this.subMenus['/favorites'].length) {
      this.subMenus['/favorites'].push({ url: '/favorites', text: 'See All' });
    }
  }

  private buildRecentItems(
    csv: string, prefix: string, basePath: string,
    itemSuffix = '', seeAllPath?: string
  ): SubMenuItem[] {
    if (!csv) return [];
    const ids = csv.split(',').filter(Boolean).slice(0, 5);
    const items: SubMenuItem[] = ids.map(id => ({
      url: basePath + id.trim() + itemSuffix,
      text: prefix + id.trim()
    }));
    const listPath = seeAllPath
      ?? (basePath.replace(/\/$/, '').split('/').slice(0, 2).join('/') || basePath);
    items.push({ url: listPath, text: 'See All' });
    return items;
  }

  getSubMenu(item: MenuItem): SubMenuItem[] {
    return this.subMenus[item.url] || [];
  }
}
